
import { ViziAPI } from "../apollo/setupViziClient";
import { CREATE_PLANO_TUSS, UPDATE_PLANO_TUSS } from "../graphql/mutations";
import { FIND_ALL_PLANO_TUSS, FIND_ALL_SERVICO, FIND_PLANO_TUSS_BY_ID } from "../graphql/queryes";


export const findAllPlanoTuss = async (variables,whitelabel) => {
   const { data } =
         ViziAPI.defaults.headers['whitelabel'] = whitelabel;
         const response = await ViziAPI.post("", {
           query: FIND_ALL_PLANO_TUSS,
           variables: variables
         });

      if (data?.errors) {
       throw new Error(data.errors[0].message);
     }

     return response.data.data.findAllPlanoTuss;
  };
export const createPlanoTuss = async (variables, whitelabel) => {

      ViziAPI.defaults.headers['whitelabel'] = whitelabel;
      const response = await ViziAPI.post("", {
        query: CREATE_PLANO_TUSS,
        variables: variables
      });
     if (response.data?.errors) {
    throw new Error(response.data.errors[0].message);
  }

  return response.data.data.createPlanoTuss;
    }


export const updatePlanoTuss = async (variables,whitelabel) => {
      ViziAPI.defaults.headers['whitelabel'] = whitelabel;
      const response = await ViziAPI.post("", {
        query: UPDATE_PLANO_TUSS,
        variables: variables
      });
      if (response.data?.errors) {
    throw new Error(response.data.errors[0].message);
  }

  return response.data.data.updatePlanoTuss;
  };

export const findAllServico = async (variables, whitelabel) => {
  try {

    const response = await ViziAPI.post(
      '',
      {
        query: FIND_ALL_SERVICO,
        variables: variables,
      },
      {
        headers: {
          whitelabel: whitelabel,
          'Content-Type': 'application/json',
        },
      }
    );

    if (response?.data?.errors) {
      throw new Error(response?.data?.errors[0].message);
    }

    return response?.data?.data?.findAllServico;
  } catch (err) {
    console.log(err);
  }
};

export const findPlanoTussById = async (variables,whitelabel) => {
  const { data } =
        ViziAPI.defaults.headers['whitelabel'] = whitelabel;
        const response = await ViziAPI.post("", {
          query: FIND_PLANO_TUSS_BY_ID,
          variables: variables
        });

    if (data?.errors) {
      throw new Error(data.errors[0].message);
    }

    return response.data.data.findPlanoTussById;
};

